import * as I from 'immutable';
import {PhoneNumber} from 'ApplicationEntry/models/PhoneNumber';
import {createAction} from 'Shared/utilities/actionCreator';
import * as PB from 'ApplicationEntry/models/PrimaryBeneficiary';
import {ZipCode} from 'ApplicationEntry/models/ZipCode';

export const updateFirstName = (index: number, value: string) =>
  createAction(PB.PrimaryBeneficiaryActionType.UPDATE_FIRST_NAME_REDUCER, {value, index});
export const updateMiddleName = (index: number, value: string) =>
  createAction(PB.PrimaryBeneficiaryActionType.UPDATE_MIDDLE_NAME_REDUCER, {value, index});
export const updateLastName = (index: number, value: string) =>
  createAction(PB.PrimaryBeneficiaryActionType.UPDATE_LAST_NAME_REDUCER, {value, index});
export const updateRelationship = (index: number, value: string) =>
  createAction(PB.PrimaryBeneficiaryActionType.UPDATE_RELATIONSHIP_REDUCER, {value, index});
export const updatePercent = (index: number, value: number) =>
  createAction(PB.PrimaryBeneficiaryActionType.UPDATE_PERCENT_REDUCER, {value, index});
export const updatePhone = (index: number, value: PhoneNumber) =>
  createAction(PB.PrimaryBeneficiaryActionType.UPDATE_PHONE_REDUCER, {value, index});
export const updateDOB = (index: number, value: Date | '') =>
  createAction(PB.PrimaryBeneficiaryActionType.UPDATE_DOB_REDUCER, {value, index});
export const updateSignatureDate = (index: number, value: Date | '') =>
  createAction(PB.PrimaryBeneficiaryActionType.UPDATE_SIGNATURE_DATE_REDUCER, {value, index});
export const updateSSN = (index: number, value: string) =>
  createAction(PB.PrimaryBeneficiaryActionType.UPDATE_SSN_REDUCER, {value, index});
export const updateAddress = (index: number, value: string) =>
  createAction(PB.PrimaryBeneficiaryActionType.UPDATE_ADDRESS_REDUCER, {value, index});
export const updateAddressLine2 = (index: number, value: string) =>
  createAction(PB.PrimaryBeneficiaryActionType.UPDATE_ADDRESS_LINE2_REDUCER, {value, index});
export const updateCity = (index: number, value: string) =>
  createAction(PB.PrimaryBeneficiaryActionType.UPDATE_CITY_REDUCER, {value, index});
export const updateState = (index: number, value: string) =>
  createAction(PB.PrimaryBeneficiaryActionType.UPDATE_STATE_REDUCER, {value, index});
export const updateZip = (index: number, value: ZipCode) =>
  createAction(PB.PrimaryBeneficiaryActionType.UPDATE_ZIP_REDUCER, {value, index});
export const addPrimaryBeneficiary = () => createAction(PB.PrimaryBeneficiaryActionType.ADD_PRIMARYBENEFICIARY_REDUCER);
export const removePrimaryBeneficiary = (index: number) =>
  createAction(PB.PrimaryBeneficiaryActionType.REMOVE_PRIMARYBENEFICIARY_REDUCER, {index});
export const emptyPrimaryBeneficiary = () =>
  createAction(PB.PrimaryBeneficiaryActionType.EMPTY_PRIMARYBENEFICIARY_REDUCER);
export const editPrimaryBeneficiary = (primaryBeneficiary: PB.PrimaryBeneficiary) =>
  createAction(PB.PrimaryBeneficiaryActionType.EDIT_PRIMARYBENEFICIARY_REDUCER, {primaryBeneficiary});

export type Action =
  | ReturnType<typeof updateFirstName>
  | ReturnType<typeof updateMiddleName>
  | ReturnType<typeof updateLastName>
  | ReturnType<typeof updateRelationship>
  | ReturnType<typeof updatePercent>
  | ReturnType<typeof updatePhone>
  | ReturnType<typeof updateDOB>
  | ReturnType<typeof updateSSN>
  | ReturnType<typeof updateAddress>
  | ReturnType<typeof updateAddressLine2>
  | ReturnType<typeof updateCity>
  | ReturnType<typeof updateState>
  | ReturnType<typeof updateZip>
  | ReturnType<typeof addPrimaryBeneficiary>
  | ReturnType<typeof removePrimaryBeneficiary>
  | ReturnType<typeof emptyPrimaryBeneficiary>
  | ReturnType<typeof editPrimaryBeneficiary>
  | ReturnType<typeof updateSignatureDate>;

export type State = {members: I.List<PB.PrimaryBeneficiary>};

export function reducer(state: State, action: Action) {
  const newState = {...state};
  let newPrimaryBeneficiary: any;
  let prevPrimaryBeneficiary: PB.PrimaryBeneficiary;
  switch (action.type) {
    case PB.PrimaryBeneficiaryActionType.ADD_PRIMARYBENEFICIARY_REDUCER:
      newState.members = state.members.push(PB.EmptyPrimaryBeneficiary);
      return {members: newState.members};
    case PB.PrimaryBeneficiaryActionType.REMOVE_PRIMARYBENEFICIARY_REDUCER:
      newState.members = state.members.delete(action.payload.index);
      return {members: newState.members};
    case PB.PrimaryBeneficiaryActionType.UPDATE_FIRST_NAME_REDUCER:
      prevPrimaryBeneficiary = state.members.get(action.payload.index) as PB.PrimaryBeneficiary;
      newPrimaryBeneficiary = PB.changeFirstName(action.payload.value)(prevPrimaryBeneficiary);
      newState.members = state.members.splice(action.payload.index, 1, newPrimaryBeneficiary);
      return {members: newState.members};
    case PB.PrimaryBeneficiaryActionType.UPDATE_MIDDLE_NAME_REDUCER:
      prevPrimaryBeneficiary = state.members.get(action.payload.index) as PB.PrimaryBeneficiary;
      newPrimaryBeneficiary = PB.changeMiddleName(action.payload.value)(prevPrimaryBeneficiary);
      newState.members = state.members.splice(action.payload.index, 1, newPrimaryBeneficiary);
      return {members: newState.members};
    case PB.PrimaryBeneficiaryActionType.UPDATE_LAST_NAME_REDUCER:
      prevPrimaryBeneficiary = state.members.get(action.payload.index) as PB.PrimaryBeneficiary;
      newPrimaryBeneficiary = PB.changeLastName(action.payload.value)(prevPrimaryBeneficiary);
      newState.members = state.members.splice(action.payload.index, 1, newPrimaryBeneficiary);
      return {members: newState.members};
    case PB.PrimaryBeneficiaryActionType.UPDATE_PERCENT_REDUCER:
      prevPrimaryBeneficiary = state.members.get(action.payload.index) as PB.PrimaryBeneficiary;
      newPrimaryBeneficiary = PB.changePercent(action.payload.value as number)(prevPrimaryBeneficiary);
      newState.members = state.members.splice(action.payload.index, 1, newPrimaryBeneficiary);
      return {members: newState.members};
    case PB.PrimaryBeneficiaryActionType.UPDATE_SSN_REDUCER:
      prevPrimaryBeneficiary = state.members.get(action.payload.index) as PB.PrimaryBeneficiary;
      newPrimaryBeneficiary = PB.changeSSN(action.payload.value)(prevPrimaryBeneficiary);
      newState.members = state.members.splice(action.payload.index, 1, newPrimaryBeneficiary);
      return {members: newState.members};
    case PB.PrimaryBeneficiaryActionType.UPDATE_RELATIONSHIP_REDUCER:
      prevPrimaryBeneficiary = state.members.get(action.payload.index) as PB.PrimaryBeneficiary;
      newPrimaryBeneficiary = PB.changeRelationship(action.payload.value)(prevPrimaryBeneficiary);
      newState.members = state.members.splice(action.payload.index, 1, newPrimaryBeneficiary);
      return {members: newState.members};
    case PB.PrimaryBeneficiaryActionType.UPDATE_DOB_REDUCER:
      prevPrimaryBeneficiary = state.members.get(action.payload.index) as PB.PrimaryBeneficiary;
      newPrimaryBeneficiary = PB.changeDOB(action.payload.value)(prevPrimaryBeneficiary);
      newState.members = state.members.splice(action.payload.index, 1, newPrimaryBeneficiary);
      return {members: newState.members};
    case PB.PrimaryBeneficiaryActionType.UPDATE_SIGNATURE_DATE_REDUCER:
      prevPrimaryBeneficiary = state.members.get(action.payload.index) as PB.PrimaryBeneficiary;
      newPrimaryBeneficiary = PB.changeSignatureDate(action.payload.value)(prevPrimaryBeneficiary);
      newState.members = state.members.splice(action.payload.index, 1, newPrimaryBeneficiary);
      return {members: newState.members};
    case PB.PrimaryBeneficiaryActionType.UPDATE_PHONE_REDUCER:
      prevPrimaryBeneficiary = state.members.get(action.payload.index) as PB.PrimaryBeneficiary;
      newPrimaryBeneficiary = PB.changePhone(action.payload.value)(prevPrimaryBeneficiary);
      newState.members = state.members.splice(action.payload.index, 1, newPrimaryBeneficiary);
      return {members: newState.members};
    case PB.PrimaryBeneficiaryActionType.UPDATE_ADDRESS_REDUCER:
      prevPrimaryBeneficiary = state.members.get(action.payload.index) as PB.PrimaryBeneficiary;
      newPrimaryBeneficiary = PB.changeAddress(action.payload.value)(prevPrimaryBeneficiary);
      newState.members = state.members.splice(action.payload.index, 1, newPrimaryBeneficiary);
      return {members: newState.members};
    case PB.PrimaryBeneficiaryActionType.UPDATE_ADDRESS_LINE2_REDUCER:
      prevPrimaryBeneficiary = state.members.get(action.payload.index) as PB.PrimaryBeneficiary;
      newPrimaryBeneficiary = PB.changeAddressLine2(action.payload.value)(prevPrimaryBeneficiary);
      newState.members = state.members.splice(action.payload.index, 1, newPrimaryBeneficiary);
      return {members: newState.members};
    case PB.PrimaryBeneficiaryActionType.UPDATE_CITY_REDUCER:
      prevPrimaryBeneficiary = state.members.get(action.payload.index) as PB.PrimaryBeneficiary;
      newPrimaryBeneficiary = PB.changeCity(action.payload.value)(prevPrimaryBeneficiary);
      newState.members = state.members.splice(action.payload.index, 1, newPrimaryBeneficiary);
      return {members: newState.members};
    case PB.PrimaryBeneficiaryActionType.UPDATE_STATE_REDUCER:
      prevPrimaryBeneficiary = state.members.get(action.payload.index) as PB.PrimaryBeneficiary;
      newPrimaryBeneficiary = PB.changeState(action.payload.value)(prevPrimaryBeneficiary);
      newState.members = state.members.splice(action.payload.index, 1, newPrimaryBeneficiary);
      return {members: newState.members};
    case PB.PrimaryBeneficiaryActionType.UPDATE_ZIP_REDUCER:
      prevPrimaryBeneficiary = state.members.get(action.payload.index) as PB.PrimaryBeneficiary;
      newPrimaryBeneficiary = PB.changeZip(action.payload.value)(prevPrimaryBeneficiary);
      newState.members = state.members.splice(action.payload.index, 1, newPrimaryBeneficiary);
      return {members: newState.members};
    case PB.PrimaryBeneficiaryActionType.EMPTY_PRIMARYBENEFICIARY_REDUCER:
      return {members: I.List<PB.PrimaryBeneficiary>().push(PB.EmptyPrimaryBeneficiary)};
    case PB.PrimaryBeneficiaryActionType.EDIT_PRIMARYBENEFICIARY_REDUCER:
      return {members: I.List<PB.PrimaryBeneficiary>().push(action.payload.primaryBeneficiary)};
    default:
      return state;
  }
}
